export default __webpack_public_path__ + "static/media/section2-bg1-h5.0bdd80a0.png";